/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsAlphabetListItem,
    SharedserviceMelcoModelsAlphabetListItemFromJSON,
    SharedserviceMelcoModelsAlphabetListItemFromJSONTyped,
    SharedserviceMelcoModelsAlphabetListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsAddAlphabetCollection
 */
export interface SharedserviceMelcoModelsAddAlphabetCollection {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAddAlphabetCollection
     */
    name?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsAlphabetListItem>}
     * @memberof SharedserviceMelcoModelsAddAlphabetCollection
     */
    alphabet_list?: Array<SharedserviceMelcoModelsAlphabetListItem> | null;
}

export function SharedserviceMelcoModelsAddAlphabetCollectionFromJSON(json: any): SharedserviceMelcoModelsAddAlphabetCollection {
    return SharedserviceMelcoModelsAddAlphabetCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsAddAlphabetCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsAddAlphabetCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'alphabet_list': !exists(json, 'alphabet_list') ? undefined : (json['alphabet_list'] === null ? null : (json['alphabet_list'] as Array<any>).map(SharedserviceMelcoModelsAlphabetListItemFromJSON)),
    };
}

export function SharedserviceMelcoModelsAddAlphabetCollectionToJSON(value?: SharedserviceMelcoModelsAddAlphabetCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'alphabet_list': value.alphabet_list === undefined ? undefined : (value.alphabet_list === null ? null : (value.alphabet_list as Array<any>).map(SharedserviceMelcoModelsAlphabetListItemToJSON)),
    };
}


